import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function CustomAccountingRule({ children }) {
  return (
    <div>
      <CustomPageHeader icon='crosshairs' text='Custom accounting rules' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/CustomAccountingRules/index.js